module.exports = __webpack_public_path__ + "img/hr1_icon.ca55ca9f.svg";